import { useEffect, useState } from "react";

export default function useModifyName(
  initial,
  editName,
  resetParent,
  showMessage,
  isFocused = true,
) {
  const [newName, setNewName] = useState("");

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  const loadData = () => {
    setNewName(initial || "");
  };

  const initData = loadData;
  const clearData = () => {
    setNewName("");
  };

  const onSubmit = async (onSuccess) => {
    const success = await submit(newName);
    resetParent?.();
    success && onSuccess?.();
    if (success) showMessage("Name erfolgreich geändert.");
    else showMessage("Name konnte nicht geändert werden!", "error");
  };

  const submit = async (newName) => {
    return editName(newName);
  };

  return {
    data: { update: loadData, clear: clearData, init: initData },
    onSubmit,
    name: { value: newName, setValue: setNewName },
  };
}
